import { Navigate } from 'react-router-dom'
import { useAuthStore } from '@/stores/authStore'
import { LoadingSpinner } from '@/components/shared/LoadingSpinner'

interface ProtectedAdminRouteProps {
  children: React.ReactNode
}

export function ProtectedAdminRoute({ children }: ProtectedAdminRouteProps) {
  const user = useAuthStore((s) => s.user)
  const loading = useAuthStore((s) => s.loading)
  const adminLoading = useAuthStore((s) => s.adminLoading)
  const isPlatformAdmin = useAuthStore((s) => s.isPlatformAdmin)

  if (loading || (user && adminLoading)) {
    return (
      <div className="flex items-center justify-center h-screen bg-[#0a0a0a]">
        <LoadingSpinner size="lg" />
      </div>
    )
  }

  if (!user) return <Navigate to="/login" replace />
  if (!isPlatformAdmin) return <Navigate to="/build" replace />

  return <>{children}</>
}
